import { Component, AfterViewChecked } from '@angular/core';
import { DataService } from '@core/services';

@Component({
  selector: 'app-continues-later',
  templateUrl: './continues-later.component.html',
  styleUrls: ['./continues-later.component.scss'],
  standalone: false
})
export class ContinuesLaterComponent implements AfterViewChecked {
  _contractorName?: string;

  constructor(public DataService: DataService) { }

  ngAfterViewChecked(): void {
    this._contractorName = JSON.parse(sessionStorage.getItem('HIPContract')).contractorName;
    sessionStorage.clear();
  }
}
